import { mapStructToInstance } from '../hooks/styles';
export default function getFeatureStyle(style) {
  var renderStyle;

  if (style) {
    try {
      renderStyle = mapStructToInstance(style);
    } catch (e) {
      console.error(e);
    }
  }

  return renderStyle;
}